import React, { useState, useContext } from 'react';
import { HandleDeleteDeal } from './requests/DealRequests';
import { DataContext } from '../../stores/crm-deal-store';
import GenericDeleteDetailsDropdownModal from './shared/GenericDeleteDetailsDropdownModal';
import { navigate } from 'hookrouter';
import { CalculateDealSettings, findPipelineIdPipelineStageIndex } from '../crm/shared/Functions';

const DealDetailsDropdownModal = () => {
    const [, setShow] = useState(false);
    const {
        store: { activeDeal, pipelines, currentPipelineId },
        dispatch,
    } = useContext(DataContext);

    const updateStoreAfterDelete = () => {
        if (typeof pipelines[currentPipelineId] !== 'undefined') {
            const [pipelineId, stageIndex] = findPipelineIdPipelineStageIndex(pipelines, activeDeal.pipelineStage.id);

            if (pipelineId && stageIndex >= 0) {
                const pipeline = pipelines[pipelineId];
                const indexToDelete = pipeline.pipelineStages[stageIndex].deals.findIndex((p) => p.id === activeDeal.id);

                pipeline.pipelineStages[stageIndex].deals.splice(indexToDelete, 1);

                pipeline.requestObject.amount -= 1;

                pipelines[currentPipelineId].viewSettings = CalculateDealSettings(
                    pipelines[currentPipelineId].viewSettings,
                    pipelines[currentPipelineId].requestObject
                );

                dispatch({
                    type: 'UPDATE_FETCH_PIPES',
                    pipelines: pipelines,
                    currentPipeline: pipelines[currentPipelineId],
                });
            }
        }
    };

    const deleteDeal = async () => {
        const response = await HandleDeleteDeal(activeDeal.id);
        if (response.success) {
            setShow(false);
            updateStoreAfterDelete();
            if (activeDeal.pipelineStage.pipelineId === '00000002-0000-0000-0000-000000000000') {
                navigate('/crmAvailableConsultants');
            } else {
                navigate('/crmDeals');
            }
            dispatch({
                type: 'UPDATE_ACTIVE_DEAL',
                payload: response.deal,
            });
        }
        return response;
    };

    return (
        <GenericDeleteDetailsDropdownModal
            title={activeDeal.name}
            description='Är du säker på att du vill radera detta kort?'
            handleDelete={deleteDeal}
        />
    );
};
export default DealDetailsDropdownModal;
